// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"d2df7e0a0c422fc21be5","293":"42a0919f82290c282f2a","452":"3242681376ea69dc0768"}[chunkId] + ".js";
};